import type { CityConfig } from "@/pages/city-template/types";

export const salinaConfig: CityConfig = {
  city: "Salina",
  state: "Kansas",
  stateAbbr: "KS",
  slug: "salina",
  route: "/cities/salina",
  title: "Emergency Passport Salina, KS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Salina, KS — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Salina and Saline County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Salina, Kansas",
  heroSubtitle: "Need an urgent passport in central Kansas? Fast Passport Center helps Salina travelers get their passports fast — as fast as 24 hours. No need to drive to a regional agency. A+ BBB rated, registered State Dept. courier.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Salina%20Kansas%20downtown%20streetscape%20with%20historic%20brick%20buildings%20and%20the%20Smoky%20Hill%20River%20winding%20through%2C%20central%20Kansas%20plains%20horizon%2C%20grain%20silos%20silhouette%20against%20golden%20sunset%20sky%2C%20midwestern%20small%20city%20charm%20with%20tree-lined%20streets%2C%20warm%20amber%20and%20wheat%20tones%2C%20photorealistic%20landscape&width=1800&height=700&seq=salina-hero-01&orientation=landscape",
  heroImageAlt: "Salina Kansas downtown streetscape along the Smoky Hill River with central plains horizon",
  geoPosition: "38.8403;-97.6114",
  geoPlacename: "Salina, Kansas",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Approximately 430 miles west — nearest regional passport agency for central Kansas travelers",
  },
  nearbyCitiesZips: [
    { name: "Salina", zips: "67401–67402" },
    { name: "Abilene", zips: "67410" },
    { name: "McPherson", zips: "67460" },
    { name: "Lindsborg", zips: "67456" },
    { name: "Concordia", zips: "66901" },
    { name: "Junction City", zips: "66441–66442" },
    { name: "Manhattan", zips: "66502–66506" },
    { name: "Ellsworth", zips: "67439" },
    { name: "Minneapolis", zips: "67467" },
    { name: "Hutchinson", zips: "67501–67504" },
    { name: "Hays", zips: "67601" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home or work in Salina in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Salina", desc: "FedEx and UPS locations throughout Salina and central Kansas offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays — especially important for last-minute passport needs." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport center — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Deborah K.",
      location: "Salina, KS",
      rating: 5,
      text: "I live in Salina and had a family emergency in Germany — my passport had expired six months ago and I needed to fly out within 4 days. Fast Passport Center handled everything. Shipped my documents from the FedEx on South 9th and had my new passport in 3 days. Made it to Frankfurt in time. I can't thank them enough.",
      service: "Emergency Passport",
    },
    {
      name: "Craig M.",
      location: "Salina, KS",
      rating: 5,
      text: "My job at Tony's Pizza required me to travel to our European facility on short notice but my passport was expired. Fast Passport Center got me a renewed passport in 5 business days. The process was smooth — no driving to a regional agency or waiting at a post office for weeks. Excellent service for central Kansans.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Abilene, KS",
      rating: 5,
      text: "Drove into Salina from Abilene to ship my documents and it was the easiest passport experience I've ever had. Needed a new passport for my daughter for a family cruise. Fast Passport Center walked me through everything, child passport requirements and all. 8 days door to door. Will use them again.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "salina-main-post",
      name: "Salina Post Office",
      type: "USPS Passport Acceptance",
      address: "211 E Ash St",
      city: "Salina",
      state: "KS",
      zip: "67401",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Downtown Salina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Main passport acceptance facility in Salina. Appointment required — book online well in advance. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "abilene-post",
      name: "Abilene Post Office",
      type: "USPS Passport Acceptance",
      address: "217 N Buckeye Ave",
      city: "Abilene",
      state: "KS",
      zip: "67410",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3:30pm",
      distance: "Abilene — about 25 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Convenient option for eastern Saline County and Dickinson County residents. Smaller facility — appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "mcpherson-post",
      name: "McPherson Post Office",
      type: "USPS Passport Acceptance",
      address: "205 S Ash St",
      city: "McPherson",
      state: "KS",
      zip: "67460",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3:30pm",
      distance: "McPherson — about 30 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative acceptance facility for southern Saline County and McPherson County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "salina-county-clerk",
      name: "Saline County Clerk's Office",
      type: "County Passport Acceptance",
      address: "300 W Ash St, Room 215",
      city: "Salina",
      state: "KS",
      zip: "67401",
      phone: "785-309-5820",
      hours: "Mon–Fri 8am–5pm",
      distance: "Downtown Salina",
      website: "https://www.saline.org/",
      websiteLabel: "Saline County Website",
      notes: "County clerk may offer passport acceptance services. Call ahead to confirm availability as services can vary by county.",
      icon: "ri-government-line",
    },
    {
      id: "concordia-post",
      name: "Concordia Post Office",
      type: "USPS Passport Acceptance",
      address: "805 Washington St",
      city: "Concordia",
      state: "KS",
      zip: "66901",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3pm",
      distance: "Concordia — about 55 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Northern option for Cloud County and north-central Kansas residents.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Salina before international travel?",
      a: "Yes. Through Fast Passport Center, Salina travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility and travel documentation. Start your order online today.",
    },
    {
      q: "How fast can I renew my passport in Salina?",
      a: "Fast passport renewal in Salina is available through Fast Passport Center in as little as 3 business days with our expedited service. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "Does Salina have its own passport agency?",
      a: "Salina, Kansas does not have a regional passport agency. The closest regional passport center is the Denver Passport Agency in Hot Springs, Arkansas (about 440 miles southeast). Fast Passport Center is the faster and more convenient solution for Salina and central Kansas residents — no 7-hour road trip required.",
    },
    {
      q: "What if my passport expires before my international business trip?",
      a: "If your passport expires before your trip, don't wait. Most countries require at least 3–6 months of passport validity beyond your stay. Fast Passport Center can expedite your passport renewal so you don't miss your travel. Many Salina professionals at companies like Schwan's and Great Plains Manufacturing travel internationally — we understand your timeline.",
    },
    {
      q: "Can I expedite a child passport in Salina?",
      a: "Yes. Child passport expediting in Salina is possible through Fast Passport Center, but child passports for minors 15 and under require an in-person acceptance step with parental consent. We provide a clear checklist and instructions so you know exactly what to expect.",
    },
    {
      q: "How long does a standard passport take in Salina?",
      a: "If you apply through a standard post office acceptance facility in Salina, processing times run 6–13 weeks — sometimes longer during peak travel season. If your travel is sooner than that, you need expedited processing. Fast Passport Center offers Salina travelers processing as fast as 24 hours.",
    },
    {
      q: "What airports do Salina passport holders typically fly from?",
      a: "Salina Regional Airport (SLN) offers limited regional flights. For international travel, most Salina residents fly from Kansas City International (MCI) about 3 hours east, or Wichita Dwight D. Eisenhower National Airport (ICT) about 1.5 hours south. Both offer international connections.",
    },
    {
      q: "Can I get a passport renewal near me in Salina without visiting an office?",
      a: "Yes. Most Salina adults who are renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, complete your documents at home, and ship them overnight from any FedEx or UPS location in Salina.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Salina", address: "2300 Planet Ave, Salina, KS 67401", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Salina", address: "1201 E Crawford St, Salina, KS 67401", hours: "Daily 8 AM – 9 PM" },
    { name: "FedEx Office — Salina", address: "2450 S 9th St, Salina, KS 67401", hours: "Mon–Fri 7:30 AM – 6 PM, Sat 9 AM – 3 PM" },
    { name: "Walmart — Salina", address: "2900 S 9th St, Salina, KS 67401", hours: "Daily 6 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Salina Driver License Office",
      address: "1825 S Ohio St, Salina, KS 67401",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Main DMV office serving Saline County. Driver licenses, REAL ID, ID cards. Appointment recommended for shorter wait times.",
      featured: true,
    },
    {
      name: "McPherson Driver License Office",
      address: "139 N Maple St, McPherson, KS 67460",
      hours: "Tue–Fri 7 AM – 5:45 PM",
      note: "Alternative DMV for southern Saline County and McPherson County residents. Closed Mondays.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SLN",
      name: "Salina Regional Airport",
      distance: "Regional airport in Salina — limited commercial service",
      address: "3237 Arnold Ave, Salina, KS 67401",
      note: "SLN offers limited regional flights. Most international travelers flying from Salina connect through Denver (DEN) or depart from larger airports.",
      flightUrl: "https://www.salinaairport.com/",
      flightLabel: "Salina Airport Website",
      featured: false,
    },
    {
      code: "ICT",
      name: "Wichita Dwight D. Eisenhower National Airport",
      distance: "Closest major airport — about 90 miles south (1.5 hours)",
      address: "2277 Eisenhower Airport Pkwy, Wichita, KS 67209",
      note: "ICT is the closest major airport for Salina travelers with domestic and some international connections. Busiest seasons are summer and holidays — plan passport needs well in advance.",
      flightUrl: "https://www.flywichita.com/",
      flightLabel: "ICT Airport Website",
      featured: true,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "Full international service — about 180 miles east (3 hours)",
      address: "1 International Sq, Kansas City, MO 64153",
      note: "MCI offers the most international flight options for Salina travelers. Direct flights to Europe, Mexico, and the Caribbean available.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from ICT or MCI in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Salina and central Kansas.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Salina and central Kansas travelers renew fast — expired passport before a trip is one of our most common urgent requests.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Salina", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Salina travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Salina families — minors under 16 require in-person acceptance and parental consent. We provide clear instructions and checklists.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Salina residents — we guide you through the acceptance clerk process and handle expedited processing.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not public lines.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all handled with the same expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Salina, Kansas travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Salina residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Salina, KS residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Salina travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Salina families with minors under 16." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Salina travelers often assume 6–8 weeks is safe — it's not. Government processing has stretched to 10–14+ weeks during peak travel season. Apply as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs and can catch these issues before documents are submitted." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks. Our checklist catches errors before submission." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Salina runs 6–13 weeks. If your trip is in under 10 weeks, standard processing is a gamble. Use our courier service instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly. Middle names, hyphens, and suffixes cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Salina travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need, nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Salina", description: "Drop off at any FedEx or UPS in Salina or central Kansas — most locations are open weekdays and Saturdays." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system entirely." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to you." },
  ],
  processingOptions: [
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center",
      tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Document review included", "Dedicated agent assigned", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center",
      tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Document review included"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)",
      tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access", "In-person clerk appointment required", "No document review", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing",
      tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required", "Life-or-death emergencies only", "Expect to wait all day or return next day"],
      highlight: false, emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots at Denver Passport Agency", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Hot Springs, AR (7 hours)", fpc: "Ship documents overnight from Salina" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Turnaround Predictability", agency: "Depends on appointment availability — no guarantee", fpc: "Guaranteed processing within selected timeframe" },
    { feature: "Customer Support", agency: "Government clerk — limited availability", fpc: "Dedicated agent assigned to your case with daily updates" },
    { feature: "Travel Required", agency: "Yes — must travel to Denver in person", fpc: "No — ship documents from home or office in Salina" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Wichita", route: "/cities/wichita" },
    { name: "Fast passport renewal in Topeka", route: "/cities/topeka" },
    { name: "Emergency passport help near Hutchinson", route: "/cities/hutchinson" },
    { name: "Fast passport services for central Kansas", route: "/states/kansas" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Salina or central Kansas — most are open weekdays and Saturdays. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Salina and all of north-central Kansas remotely",
  serviceAreaIntro: "Whether you are in Salina, Abilene, McPherson, Lindsborg, or anywhere in Saline County, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Salina and Saline County zip codes. Anywhere in central Kansas — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Salina as simple as possible. Most Salina clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Salina travelers. Fast Passport Center reviews your documents before submission to catch these issues.",
  testimonialsIntro: "Real reviews from Salina and central Kansas travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Salina and Saline County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/kansas",
  statePageName: "Kansas",
};